import React from 'react';
import searchesHero from '../../images/searchesHero.svg';
import CreateSearchButton from 'v2/common/CreateSearchButton/CreateSearchButton';
import classnames from 'classnames';
import styles from './noActiveSearchesSplash.module.scss';
import { useMasterOrganization } from 'v2/queries/useMasterOrganization';
import UnqualifiedMsg from '../UnqualifiedMsg/UnqualifiedMsg';
import { useFreeUser } from 'v2/hooks/useFreeUser';

const NoActiveSearchesSplash = () => {
  const [isFreeUser] = useFreeUser();
  const { data: masterOrganization } = useMasterOrganization();

  if (isFreeUser && masterOrganization?.unqualified) {
    return <UnqualifiedMsg />;
  }

  return (
    <div
      className={classnames(
        'h-100 w-100 d-flex align-items-center px-1 px-md-5',
        styles.noActiveContainer
      )}
    >
      <div className={classnames('position-absolute', styles.textContent)}>
        <h1>You Have No Active Requests!</h1>
        {isFreeUser ? (
          <ul>
            <li>Create a free Request below.</li>
            <li>
              Once your account has been verified and approved, you will receive
              an email notification with the first response to your request.
            </li>
            <li>
              Subscribe to engage with the provider and receive responses from
              additional providers.
            </li>
          </ul>
        ) : (
          <p>Create one now.</p>
        )}
        <div className="d-flex">
          <CreateSearchButton />
        </div>
      </div>
      <div>
        <img
          className={classnames('w-100 img-fluid', styles.textImg)}
          src={searchesHero}
          alt="searchesHeroImage"
        ></img>
      </div>
    </div>
  );
};

export default NoActiveSearchesSplash;
